import { createApp } from "vue"
import { vuetify } from "./plugins/vuetify"

import axios from "axios"

// Styles
import "../css/app.css"

// Custom public components
import CookieConsentView from "./components/CookieConsentView.vue"
import CtaCardOne from "./components/CtaCardOne.vue"
import CtaCardTwo from "./components/CtaCardTwo.vue"
import NameGenerator from "./components/NameGenerator.vue"
import CalculatorFormula from "./components/CalculatorFormula.vue"
import Partners from "./components/Partners.vue"
import DocSwiper from "./components/DocSwiper.vue"
import ToolsGrid from "./components/ToolsGrid.vue"
import ComparisonTable from "./components/ComparisonTable.vue"
import QuickTool from "./components/QuickTool.vue"

//
import AdminSidebar from "./components/AdminSidebar.vue"
import AdminModuleRecords from "./components/AdminModuleRecords.vue"
import AdminAnalytics from "./components/AdminAnalytics.vue"
import AdminCreateModule from "./components/AdminCreateModule.vue"
import AdminShowRecord from "./components/AdminShowRecord.vue"
import StepsCard from "./components/StepsCard.vue"

const app = createApp({})

app.config.globalProperties.$axios = axios
app.use(vuetify)

app.component("cookie-consent-view", CookieConsentView)
app.component("cta-card-one", CtaCardOne)
app.component("cta-card-two", CtaCardTwo)
app.component("steps-card", StepsCard)
app.component("name-generator", NameGenerator)
app.component("calculator-formula", CalculatorFormula)
app.component("partners", Partners)
app.component("doc-swiper", DocSwiper)
app.component("tools-grid", ToolsGrid)
app.component("comparison-table", ComparisonTable)
app.component("quick-tool", QuickTool)

app.component("admin-sidebar", AdminSidebar)
app.component("admin-module-records", AdminModuleRecords)
app.component("admin-analytics", AdminAnalytics)
app.component("admin-create-module", AdminCreateModule)
app.component("admin-show-record", AdminShowRecord)

app.mount("#app")
